import Util from '@/libs/util'
//getToken接口
export const getToken = data => Util.http.get(`/wechat/core/mp/token?code=${data.code}`, data);
//添加邮箱接口
export const addEmail = data => Util.http.post('/wechat/email/', data);
//查询邮箱，邮箱列表
export const queryEmail = data => Util.http.get('/wechat/email/', data);
//删除邮箱 /wechat/email/{id}
export const deleteEmail = data => Util.http.delete('/wechat/email/' + data.id, data);
//修改邮箱
export const changeEmail = data => Util.http.post('/wechat/email/update', data);
//获取JSSDK
export const JSSDK = data => Util.http.get(`/wechat/core/jssdk?url=${data.url}`, data);
//获取用户最新邮件地址
export const getNewEmail = data => Util.http.get('/wechat/email/getNew', data);
//coc查询
export const queryCocOrder = data => Util.http.get(`/wechat/coc/base?batchNumber=${data.batchNumber}`, data);
//coa校验
export const verifyCocOrder = data => Util.http.get(`/wechat/coa/validator?deliveryNumber=${data.deliveryNumber}&choice=${data.choice}`, data);
//coa查询
export const queryCoaOrder = data => Util.http.get(`/wechat/coa/base?deliveryNumber=${data.deliveryNumber}&barcode=${data.barcode}&choice=${data.choice}`, data);
//邮件推送
export const sendEmail = data => Util.http.get(`/wechat/email/push?htmlBody=${data.htmlBody}&address=${data.address}&subjectBody=${data.subjectBody}`, {});
//coc报告
export const cocReport = data => Util.http.get(`/wechat/coc/detail?barcode=${data.barcode}&iccBatchNo=${data.iccBatchNo}&basetype=${data.basetype}`, data);
//coa报告
export const coaReport = data => Util.http.get(`/wechat/coa/detail?barcode=${data.barcode}&iccBatchNo=${data.iccBatchNo}&deliveryNumber=${data.deliveryNumber}&enterstatu=${data.enterstatu}`, data);
// 查询
export const queryFind = data => Util.http.get(`/wechat/retro?barcode=${data.retro}`, data);




// WEBPACK FOOTER //
// ./src/api/index.js